import { fetch } from "src/services/apollo-fetch";
import { Query, Mutation } from "../_api";

export default {
    async addPreOrder({ commit }, data) {
        const response = await fetch.mutate(
            {
                mutation: Mutation.addPreOrder,
                variables: { input: data },
            },
            { message: "Preorder added" },
        );
        commit("addPreOrder", response.data.addPreOrder);
        return response.data.addPreOrder;
    },
    setPreOrdersPerPage({ commit }, data) {
        commit("setPreOrdersPerPage", data);
    },
    async fetchPreOrders({ commit }, data) {
        const response = await fetch.query({
            query: Query.preOrders,
            variables: data,
        });
        commit("setPreOrders", response.data.preOrders);
    },
};
